window.onload = function(){
	chushihuazihao();
}
window.onresize = function(){
	chushihuazihao();
}
function chushihuazihao(){
	var deviceWidth = document.documentElement.clientWidth;
	if(deviceWidth < 320) deviceWidth = 320;
	var fontSize = deviceWidth / 15;
	if(deviceWidth>768){
		fontSize = deviceWidth / 19 / 2;
	}
	if(deviceWidth>1024){
		fontSize = deviceWidth / 20 / 2;
	}
	document.documentElement.style.fontSize =  fontSize+ 'px';
	return deviceWidth
}
export default chushihuazihao;



// WEBPACK FOOTER //
// ./src/assets/js/font.js